import { Heading } from '@cinch-labs/design-system'
import { useLatestVehicles } from '@cinch-nx/landing-ui-shared'

import { Carousel as LatestCarsCarousel } from '../carousel/carousel'

import styles from './latest-cars.module.css'
import sharedStyles from '../../car-reviews-v2.module.css'
import { capitaliseFirstLetter } from '../../utils'

interface LatestCarsProps {
  make: string
  model: string
}

export const LatestCars = ({ make, model }: LatestCarsProps) => {
  const { data, error } = useLatestVehicles({
    make: make,
    model: model,
    count: 5,
    caller: 'makesAndModels',
  })

  if (!data) {
    return <div className={styles.carouselLoading}>Loading...</div>
  }

  if (error) {
    console.log(error)
    return null
  }

  if (data.vehicleListings.length === 0) {
    return null
  }

  return (
    <section className={sharedStyles.inner}>
      <Heading className={styles.title}>
        Latest {capitaliseFirstLetter(make)}{' '}
        {model && capitaliseFirstLetter(model)}
      </Heading>
      <LatestCarsCarousel
        carouselName="latest-cars"
        vehicles={data.vehicleListings}
      />
    </section>
  )
}
